import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ResultParams {
  from: string;
  to: string;
}

export interface ResultItem {
  account_name: string;
  period: string; // date string or milliseconds? Legacy pushes to chart values.
  value: number;
}

@Injectable({
  providedIn: 'root',
})
export class ResultService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  get(params: ResultParams): Observable<ResultItem[]> {
    // Legacy: "api/result/:from/:to"
    return this.http.get<ResultItem[]>(`api/result/${params.from}/${params.to}`);
  }
}
